export default __webpack_public_path__ + "static/media/Saloni.aac518ff.jpg";